import { Record } from "immutable";

export interface MailTemplateUpdateFormParams {
    body: string | null;
    title: string | null;
    from_address: string | null;
    from_name: string | null;
}

const defaults: MailTemplateUpdateFormParams = {
    body: null,
    title: null,
    from_address: null,
    from_name: null,
};

class MailTemplateUpdateForm extends Record<MailTemplateUpdateFormParams>(defaults) {
    constructor(values?: Partial<MailTemplateUpdateFormParams>) {
        super(values ? { ...defaults, ...values } : defaults);
    }

    createFormData(): string {
        if (!this.title) {
            throw new Error("Title must be defined");
        }
        if (!this.from_address) {
            throw new Error("From address must be defined");
        }
        if (!this.from_name) {
            throw new Error("From name must be defined");
        }

        // Create a JSON object with the necessary fields
        const obj = {
            body: this.body,
            title: this.title,
            from_address: this.from_address,
            from_name: this.from_name,
        };
        console.log("MailTemplateUpdateForm JSON:", obj);
        return JSON.stringify(obj);
    }
}

export default MailTemplateUpdateForm;
